export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    cardNumber = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    handoverDocNumber = "",
    handoverDocDate = "",
    assetName = "",
    assetId = "",
    manufacturingCountry = "",
    manufacturingYear = "",
    managementDepartment = "",
    useYear = "",
    capacity = "",
    suspensionDate = "",
    suspensionReason = "",
    costAndDepreciation = [],
    attachedTools = [],
    reductionDocNumber = "",
    reductionDocDate = "",
    reductionReason = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let table1Rows = costAndDepreciation.map((item) => `
    <tr>
      <td class="border text-center">${item.docNumber || ""}</td>
      <td class="border text-center">${item.costDate || ""}</td>
      <td class="border px-1">${item.description || ""}</td>
      <td class="border text-right px-1">${fmt(item.costValue)}</td>
      <td class="border text-center">${item.depreciationYear || ""}</td>
      <td class="border text-right px-1">${fmt(item.depreciationValue)}</td>
      <td class="border text-right px-1">${fmt(item.accumulatedValue)}</td>
    </tr>
  `).join("");

  let table2Rows = attachedTools.map((item) => `
    <tr>
      <td class="border text-center">${item.ordinalNumber || ""}</td>
      <td class="border px-1">${item.name || ""}</td>
      <td class="border text-center">${item.unit || ""}</td>
      <td class="border text-center">${fmt(item.quantity)}</td>
      <td class="border text-right px-1">${fmt(item.value)}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S23-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 16px;">THẺ TÀI SẢN CỐ ĐỊNH</h2>
        <div style="margin-top: 5px;">Số: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 10px;">${cardNumber}</span></div>
        <div style="font-style: italic; margin-top: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear} lập thẻ</div>
      </div>

      <div style="margin-top: 15px;">
        <div>Căn cứ vào Biên bản giao nhận TSCĐ số: <span class="dotted-line">${handoverDocNumber}</span> ngày <span class="dotted-line">${handoverDocDate}</span></div>
        <div style="display: flex;">
          <div style="flex: 2;">Tên, ký mã hiệu, quy cách (cấp hạng) TSCĐ: <span class="dotted-line">${assetName}</span></div>
          <div style="flex: 1;">Số hiệu TSCĐ: <span class="dotted-line">${assetId}</span></div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;">Nước sản xuất (xây dựng): <span class="dotted-line">${manufacturingCountry}</span></div>
          <div style="flex: 1;">Năm sản xuất: <span class="dotted-line">${manufacturingYear}</span></div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;">Bộ phận quản lý, sử dụng: <span class="dotted-line">${managementDepartment}</span></div>
          <div style="flex: 1;">Năm đưa vào sử dụng: <span class="dotted-line">${useYear}</span></div>
        </div>
        <div>Công suất (diện tích thiết kế): <span class="dotted-line">${capacity}</span></div>
        <div>Đình chỉ sử dụng TSCĐ ngày: <span class="dotted-line">${suspensionDate}</span></div>
        <div>Lý do đình chỉ: <span class="dotted-line">${suspensionReason}</span></div>
      </div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr>
            <th class="border" colspan="3">Nguyên giá tài sản cố định</th>
            <th class="border" colspan="4">Giá trị hao mòn tài sản cố định</th>
          </tr>
          <tr>
            <th class="border" width="60">Số hiệu chứng từ</th>
            <th class="border" width="70">Ngày, tháng, năm</th>
            <th class="border">Diễn giải</th>
            <th class="border" width="80">Nguyên giá</th>
            <th class="border" width="40">Năm</th>
            <th class="border" width="80">Giá trị hao mòn</th>
            <th class="border" width="80">Cộng dồn</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
          </tr>
        </thead>
        <tbody>
          ${table1Rows}
        </tbody>
      </table>

      <div style="text-align: center; font-weight: bold; text-transform: uppercase; margin-top: 15px;">Dụng cụ phụ tùng kèm theo</div>
      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 5px;">
        <thead>
          <tr>
            <th class="border" width="40">Số TT</th>
            <th class="border">Tên, quy cách dụng cụ, phụ tùng</th>
            <th class="border" width="60">Đơn vị tính</th>
            <th class="border" width="60">Số lượng</th>
            <th class="border" width="80">Giá trị</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">1</th>
            <th class="border">2</th>
          </tr>
        </thead>
        <tbody>
          ${table2Rows}
        </tbody>
      </table>

      <div style="margin-top: 15px;">
        <div>Ghi giảm TSCĐ chứng từ số: <span class="dotted-line">${reductionDocNumber}</span> ngày <span class="dotted-line">${reductionDocDate}</span></div>
        <div>Lý do giảm: <span class="dotted-line">${reductionReason}</span></div>
      </div>

      <table width="100%" style="margin-top: 25px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 10px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 50px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 4px; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; padding: 0 10px; }
      </style>
    </div>
  `;
};
